import { render, staticRenderFns } from "./about-panel-new.vue?vue&type=template&id=275c4576"
import script from "./about-panel-new.vue?vue&type=script&lang=js"
export * from "./about-panel-new.vue?vue&type=script&lang=js"
import style0 from "./about-panel-new.vue?vue&type=style&index=0&id=275c4576&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports